import moment from "moment";

export const colors = {
	black: "#3F3F3F",
	main: "#BE2917",
	ss: "#B25027",
	white: "#FFFFFF",
	grisclaro: "#E0E0E0",
	grisoscuro: "#353535",
	grisMapa: "#F2F2F2",
	alto: "#F4F3F4",
	ss2: "#F37E28",
	veryWarm: "#FF8500",
	warm: "#ffc600",
	normal: "#94AF10",
	cold: "#06799F",
	veryCold: "#233884",
	azul: "#19262E",
	stack: "'Roboto', sans-serif",
	// stackSerif: "'Roboto Slab', serif",
	// stackSerif: "'ExpressoTextoMedium', serif"
	stackSerif: "'Roboto', sans-serif",
	grafica: "#C59F5E"
};

export const minusSinEspacio = string => {
	return string
		.toLowerCase()
		.split(" ")
		.join("");
};

export const primeraMay = string => {
	return string.charAt(0).toUpperCase() + string.slice(1, string.length);
};

export const lluviaRojo = string => {
	return string.includes('lluvia') ? true : false;
};

export const latlng = array => {
	return { lat: array[0], lng: array[1] };
};

export const soloHoras = time => {
	return moment(time).fromNow();
};

export const restanteHoras = time => {
	return moment(time).format("HH:mm");
};

export const masCercana = (dates, target) => {};

export const proximo = x => {
	let arrayDiferencia = x.reduce((acc, curr, index, array) => {
		let ahora = moment("2018-03-25T19:05");
		// let ahora = moment();
		let current = curr.hora;
		let diferencia = ahora.diff(current);
		if (diferencia < 0) {
			acc.push(index);
		}
		return acc;
	}, []);
	return arrayDiferencia[0];
};

export const isMobile = () => {
	return (
		typeof window.orientation !== "undefined" ||
		navigator.userAgent.indexOf("IEMobile") !== -1
	);
};

export const isCurrentDate = (today) => {
	return today.isSame(moment());
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js